import type {HorizonContext} from './operational-ranking'
import {rankTerminalRows} from './operational-ranking'
import type {TerminalRowEntry} from './terminal-jobs'

/** Ranked entries per operational lane — shared by every board layout. */
export type RankedLaneSections = {
    needsAction: TerminalRowEntry[]
    notifyDrivers: TerminalRowEntry[]
    dispatched: TerminalRowEntry[]
}

export function rankLaneSections(
    entries: TerminalRowEntry[],
    horizonContext: HorizonContext,
): RankedLaneSections {
    return {
        needsAction: rankTerminalRows(
            entries.filter((entry) => entry.lane === 'needs_action'),
            'needs_action',
            horizonContext,
        ),
        notifyDrivers: rankTerminalRows(
            entries.filter((entry) => entry.lane === 'notify_drivers'),
            'notify_drivers',
            horizonContext,
        ),
        dispatched: rankTerminalRows(
            entries.filter((entry) => entry.lane === 'dispatched'),
            'dispatched',
            horizonContext,
        ),
    }
}
